import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { H4, ParagraphRegular } from '@/components/text'
import { Stack } from '@/components/structure'
import { createModal, useModalize } from '@/components/modalize/mui'
import { headKey } from '@/utils'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 24px 40px;
  max-height: 95vh;
  margin: auto;
  text-align: center;
`

const RelistModal = ({ listingId, history }) => {
  const { close } = useModalize()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const duplicateData = async () => {
    const { body, error } = await dispatch.listing.cloneListing(listingId)
    if (!error) {
      close()
      const newlistingId = headKey(body.listings)
      history.replace(`/listing/create/${newlistingId}/details`)
    }
  }

  return (
    <Wrapper>
      <Stack gutter={24}>
        <H4>{t('l.listing.relist_modal_proceed.title', 'Warning: Active Tenancy')}</H4>
        <ParagraphRegular>
          {t(
            'l.listing.relist_modal_proceed.description',
            'You may still proceed to re-list your unit. However, you must end the current tenancy before sending a new contract.'
          )}
        </ParagraphRegular>
        <Stack gutter={16}>
          <Button theme="primary" onClick={duplicateData}>
            {t('common.proceed', 'Proceed')}
          </Button>
          <Button theme="secondary" onClick={close}>
            {t('common.cancel', 'Cancel')}
          </Button>
        </Stack>
      </Stack>
    </Wrapper>
  )
}

export const showRelistModal = createModal(RelistModal)
